import { render } from "./contentgroup.html?vue&type=template&id=041ba6b8&scoped=true&external"
import script from "./contentgroup.ts?vue&type=script&lang=js&external"
export * from "./contentgroup.ts?vue&type=script&lang=js&external"

import "./contentgroup.scss?vue&type=style&index=0&id=041ba6b8&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041ba6b8"],['__file',"src/components/ui/contentgroup/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "041ba6b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('041ba6b8', __exports__)) {
    api.reload('041ba6b8', __exports__)
  }
  
  module.hot.accept("./contentgroup.html?vue&type=template&id=041ba6b8&scoped=true&external", () => {
    api.rerender('041ba6b8', render)
  })

}


export default __exports__